import OuterClick from './outer_click';

export default OuterClick;
